<template>
    <div class="sub-tabs">
        <b-tabs v-model="tabs"
                lazy
                fill
        >
            <b-tab title="Método sumatorio">
                <summation_method v-if="tabs === 0"/>
            </b-tab>

            <b-tab title="Factor M">
                <factor_m v-if="tabs === 1"/>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>

import summation_method from './summation_method/index.vue';
import factor_m from './factor_m.vue';

export default {
    name: 'index',
    components: {
        summation_method,
        factor_m
    },
    data() {
        return {
            tabs: 0
        };
    }
};
</script>

<style lang="scss"
       src="../../../../../assets/calculator.scss"
/>
